import { render, staticRenderFns } from "./DiamondSparkleIcon.vue?vue&type=template&id=0c9b2c34&"
import script from "./DiamondSparkleIcon.vue?vue&type=script&lang=js&"
export * from "./DiamondSparkleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports